import SectionWrapper from '../components/SectionWrapper';
import ScrollReveal from '../components/ScrollReveal';
import StatCounter from '../components/StatCounter';
import ChartBarAbility from '../charts/ChartBarAbility';
import { PAIN_POINTS } from '../data/mockData';
import { FileText, Users, Wallet } from 'lucide-react';

// 区块2：项目背景与痛点
export default function Section02Background() {
  const painIcons = [FileText, Users, Wallet];

  return (
    <SectionWrapper
      id="background"
      title="项目背景与痛点"
      subtitle="基于国家强师计划、县中振兴与教育数字化战略，本项目针对师范生培养与县域师资供给双重痛点，构建AI驱动的微格实训新范式。"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
        {/* 左侧：政策背景 + 三大痛点 */}
        <div className="flex flex-col gap-6">
          <ScrollReveal>
            <div className="glass-card">
              <h3 className="text-2xl font-bold text-gold mb-4">政策背景</h3>
              <ul className="space-y-3 text-lg text-slate-200">
                <li className="flex items-start gap-3">
                  <span className="text-cyan font-bold">01</span>
                  <span>《新时代基础教育强师计划》明确提出提升师范生教学实践能力</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-cyan font-bold">02</span>
                  <span>《"十四五"县域普通高中发展提升行动计划》聚焦县中师资短缺难题</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-cyan font-bold">03</span>
                  <span>教育数字化战略行动推动AI与教师培养深度融合</span>
                </li>
              </ul>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={150}>
            <div className="glass-card">
              <h3 className="text-2xl font-bold text-gold mb-4">三大核心痛点</h3>
              <ul className="space-y-3 text-lg text-slate-200">
                <li className="flex items-start gap-3">
                  <span className="text-orange font-bold">●</span>
                  <span>传统微格评价依赖主观打分，缺乏数据沉淀与量化追踪</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-orange font-bold">●</span>
                  <span>县域中学面临结构性师资荒，优质教学资源难以持续输入</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-orange font-bold">●</span>
                  <span>现有智慧教室解决方案硬件成本高达18万元/间，部署门槛极高</span>
                </li>
              </ul>
            </div>
          </ScrollReveal>
        </div>

        {/* 右侧：能力维度柱状图 */}
        <ScrollReveal delay={200}>
          <div className="glass-card h-full min-h-[460px]">
            <ChartBarAbility />
          </div>
        </ScrollReveal>
      </div>

      {/* 底部：3张痛点数据卡片 */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
        {PAIN_POINTS.map((item, index) => {
          const Icon = painIcons[index];
          return (
            <ScrollReveal key={index} delay={100 * index}>
              <div className="glass-card text-center">
                <Icon className="w-12 h-12 text-gold mx-auto mb-4" />
                <div className="stat-number text-5xl mb-2">
                  <StatCounter value={item.value} suffix={item.suffix} />
                </div>
                <div className="text-xl font-bold text-white mb-2">{item.label}</div>
                <div className="text-sm text-slate-400">{item.desc}</div>
              </div>
            </ScrollReveal>
          );
        })}
      </div>
    </SectionWrapper>
  );
}
